import { useEffect, useState } from "react";
import { _EcmDocument, _single } from "../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../core/services/dataBean/useDataBean"
import { BasicPage } from "../../theme/Component/BasicPage"
import { SingPanelEditor } from "../../contabilidad/SignAndApprovalPanel/SingPanelEditor";
import { CardTaps } from "../../theme/Component/CardTaps";
import { AccountEditor } from "../../editor/AccountEditor";
import { DocumentStorageEditor } from "../../contabilidad/bodegaDocumentos/DocumentStorageEditor";
import { BasicButton } from "../../theme/Component/BasicButton";
import { toast } from "react-toastify";
import { DocumentViewer } from "../../theme/Component/DocumentViewer";
import { AdminProcess } from "../../erp/cellEditor/PaymentHeader/AdminProcess";
import { BasicSwitch } from "../../theme/Component/BasicSwitch";
import { Modal } from "../../theme/Component/Modal";
import { _SignAndApprovalitem } from "../../../core/services/dataBean/EntityCatalogVdos";
import { BasicTable } from "../../theme/Component/BasicTable";
import { PrintJson } from "../../theme/Component/PrintJson";


export const RequestSignPanel = () => {

    const { instance } = useDataBean(_EcmDocument);
    const sign = useDataBean(_SignAndApprovalitem);

    const [data, setData] = useState<any>({});
    const [doc, setDoc] = useState<any>([]);
    let taps = [
        { id: 0, name: 'Documentos', disable: false },
        { id: 1, name: 'Proceso', disable: false }
    ];
    const [indexTap, setIndexTap] = useState(0);

    const [showJson, setShowJson] = useState(false);
    const [confirmModal, setConfirmModal] = useState({ view: false, name: "Confirmar acción", message: "", onConfirm: () => { }, btnClose: true, btnSubmit: true, format: "modal-md", });

    useEffect(() => {

        return () => {
            setDoc([]);
            setData({});
        }
    }, [])
    useEffect(() => {


        setDoc([]);
        setData({});

    }, [indexTap])


    const fireSigningDocumentFlow = () => {
        if (data.DocumentState == 1) {
            toast.warning("El documento que intenta firmar esta anulado");

        } else {

            instance.fireSigningDocumentFlow(data.IDDocument, data.Mnemonic, data.DocumentDate, data.IDSignPanel, _single.getAccountID()).then((resp: any) => {

                toast.success(resp);

            })
        }

    }

    const createEcmDocumentForFlowControl = () => {

        instance.createEcmDocumentForFlowControl(data.IDSignPanel, data.IDAccount, data.Obs, null, data.IDProcess ?? null, data.ProcessDate ?? null, _single.getAccountID()).then((resp: any) => {

            console.log(resp);
            if (resp.DocumentURL) {
                toast.success("Proceso iniciado correctamente");
                setDoc(resp.DocumentURL);
                if (data.StartSign === true) {
                    if (resp.IDDocument > 0) {

                        instance.fireSigningDocumentFlow(resp.IDDocument, resp.Mnemonic, resp.DocumentDate, data.IDSignPanel, _single.getAccountID()).then(
                            (resp: any) => {
                                toast.success(resp);
                            }
                        )

                    } else {

                    }
                }

            } else {
                toast.warning("Proceso no pudo iniciar");
            }
        })
    }

    const getSignedItems = (idSigned: number) => {
        sign.instance.getSignAndApprovalItemCatalog(idSigned).then(
            (resp) => {
                sign.setLista(resp)
            }
        ).catch(
            err => {
                toast.error("No se pudieron Cargar las firmas")
            }
        )
    }

    const openConfirmModal = (message: string, action: () => void) => {
        setShowJson(false);
        setConfirmModal({
            view: true,
            name: "Confirmación de Acción",
            message,
            onConfirm: () => {
                action();
                setConfirmModal(prev => ({ ...prev, view: false }));
            },
            btnClose: true,
            btnSubmit: true,
            format: "modal-md",
        });
    };

    const head = [
        { title: 'Título de Firma', property: 'Title', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Tipo', property: 'TypeName', visible: true },
        { title: 'Funcionario', property: 'AccountName', visible: true },
    ]

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            createEcmDocumentForFlowControl();
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "IDSignPanel", "IDAccount", "Obs"
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (data[field] === null || data[field] === undefined || data[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    return (
        <BasicPage titulo="Solicitud Firma">

            <div className="row">
                <div className="col-md-12">
                    <CardTaps taps={taps} index={indexTap} updateIndex={setIndexTap} >
                        {indexTap === 0 &&
                            <div className="row">
                                <div className="col-md-6">
                                    <DocumentStorageEditor label="Documento" onChange={(e) => { setData({ ...data, ...e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <SingPanelEditor idSelector={data.IDSignPanel} onChange={(e) => { setData({ ...data, "IDSignPanel": e }) }} />
                                </div>
                                <div className="col-md-6 mt-4">
                                    <BasicButton
                                        icon="ri-file-edit-line"
                                        eventClick={() => {
                                            if (!data.IDSignPanel) {
                                                toast.error("Debe Seleccionar un Panel de firmas Valido para la solicitud");
                                                return
                                            } else if (!data.IDDocument) {
                                                toast.error("Debe Seleccionar un Documento Valido para la solicitud");
                                                return
                                            }
                                            openConfirmModal(`"¿Desea iniciar el flujo de firmas previamente seleccionado para el documento ${data.Mnemonic} - ${data.Consecutive}?"`, fireSigningDocumentFlow)
                                        }}
                                    >
                                        Iniciar Solicitud
                                    </BasicButton>

                                </div>
                            </div>
                        }
                        {indexTap === 1 &&
                            <div className="row">
                                <div className="col-md-6">
                                    <label className={`${missingFields.includes('IDSignPanel') ? 'has-error' : ''}`}>Panel de Firma</label>
                                    <SingPanelEditor idSelector={data.IDSignPanel} label=" " onChange={(e) => { setData({ ...data, "IDSignPanel": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <label className={`${missingFields.includes('IDAccount') ? 'has-error' : ''}`}>Solicitante</label>
                                    <AccountEditor idAccount={data.IDAccount} onChange={({ IDAccount }) => { setData({ ...data, "IDAccount": IDAccount }) }} label=" " />
                                </div>
                                <div className="col-md-6">
                                    <AdminProcess idSelector={0} label="Proceso" onChange={(e) => { setData({ ...e, ...data }) }} />
                                </div>
                                <div className="col-md-6">
                                    <BasicSwitch label="Iniciar flujo de firmas" estado={data.StartSign ?? false} eventChange={(e) => { setData({ ...data, "StartSign": e }) }} />
                                </div>
                                <div className="col-md-12">
                                    <label className={`${missingFields.includes('Obs') ? 'has-error' : ''}`}>Descripción de la solicitud</label>
                                    <textarea name="ob" className="form-control" value={data.Obs} onChange={(e) => { setData({ ...data, "Obs": e.target.value }) }}></textarea>
                                </div>
                                <div className="col-md-6 mt-4 ">
                                    <BasicButton
                                        icon="ri-file-edit-line"
                                        eventClick={() => openConfirmModal("¿Desea generar el proceso?", validateData)}
                                    >
                                        Iniciar Solicitud
                                    </BasicButton>
                                </div>

                                {/* <div className="col-md-6 mt-4">
                                    <BasicButton icon="ri-file-edit-line" eventClick={createEcmDocumentForFlowControl}>Iniciar Solicitud</BasicButton>
                                </div> */}
                                {doc.length > 0 &&
                                    <DocumentViewer list={doc} />
                                }
                            </div>
                        }
                        <Modal
                            modal={confirmModal}
                            updateModal={(m) => {
                                setConfirmModal(m);
                                if (!m.view) setShowJson(false);
                            }}
                            eventModal={confirmModal.onConfirm}
                            onSubmitLabel="Confirmar solicitud"
                        >
                            <div className="row p-3">
                                <div className="col-md-12 mb-3 text-center">
                                    <p>{confirmModal.message}</p>
                                </div>

                                {/* <div className="col-md-12 text-center ">
                                    <BasicButton
                                        icon={showJson ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}
                                        eventClick={() => {
                                            const next = !showJson;
                                            setShowJson(next);
                                            if (next) getSignedItems(data.IDSignPanel);
                                        }}
                                    >
                                        {showJson ? "Ocultar Firmas" : "Ver Firmas"}
                                    </BasicButton>
                                </div> */}

                                {showJson && (
                                    <div className="col-md-12">
                                        <BasicTable body={sign.lista} head={head} rowSet={() => { }} />
                                    </div>
                                )}
                            </div>
                        </Modal>

                    </CardTaps>
                </div>
            </div>
        </BasicPage>
    )
}
